/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Assessment creation request
 * @export
 * @interface AssessmentCreateRequest
 */
export interface AssessmentCreateRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentCreateRequest
     */
    controlIds?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AssessmentCreateRequest
     */
    groupIds?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof AssessmentCreateRequest
     */
    scaffoldAll?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AssessmentCreateRequest
     */
    title?: string;
}

/**
 * Check if a given object implements the AssessmentCreateRequest interface.
 */
export function instanceOfAssessmentCreateRequest(value: object): value is AssessmentCreateRequest {
    return true;
}

export function AssessmentCreateRequestFromJSON(json: any): AssessmentCreateRequest {
    return AssessmentCreateRequestFromJSONTyped(json, false);
}

export function AssessmentCreateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssessmentCreateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'controlIds': json['controlIds'] == null ? undefined : json['controlIds'],
        'groupIds': json['groupIds'] == null ? undefined : json['groupIds'],
        'scaffoldAll': json['scaffoldAll'] == null ? undefined : json['scaffoldAll'],
        'title': json['title'] == null ? undefined : json['title'],
    };
}

export function AssessmentCreateRequestToJSON(json: any): AssessmentCreateRequest {
    return AssessmentCreateRequestToJSONTyped(json, false);
}

export function AssessmentCreateRequestToJSONTyped(value?: AssessmentCreateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'controlIds': value['controlIds'],
        'groupIds': value['groupIds'],
        'scaffoldAll': value['scaffoldAll'],
        'title': value['title'],
    };
}

